<template>
    <Toast position="top-right" />
</template>

<script setup>
// This component only handles the Toast component styling and positioning
// For notifications, use the useNotifications composable in your components
</script>

<style lang="scss">
/* Toast customization for dark theme */
.p-toast {
    z-index: 9999;
}

.p-toast .p-toast-message {
    background: var(--theme-surface, #2F2F2F);
    border: 1px solid var(--theme-border, #3B3B3B);
    border-radius: 0.75rem;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    margin: 0 0 1rem 0;
    min-width: 300px;
    max-width: 400px;
}

.p-toast .p-toast-message .p-toast-message-content {
    padding: 1rem 1.25rem;
    border: none;
    border-radius: 0.75rem;
}

.p-toast .p-toast-message .p-toast-message-text {
    margin: 0;
}

.p-toast .p-toast-message .p-toast-summary {
    font-weight: 600;
    font-size: 0.9rem;
    color: var(--theme-text, #ffffff);
    margin: 0 0 0.25rem 0;
}

.p-toast .p-toast-message .p-toast-detail {
    font-size: 0.85rem;
    color: var(--theme-muted, #B4B4B4);
    margin: 0;
    line-height: 1.4;
}

.p-toast .p-toast-message .p-toast-icon-close {
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    background: transparent;
    color: var(--theme-text, #ffffff);
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 0.5rem;
    transition: background-color 0.2s ease;
}

.p-toast .p-toast-message .p-toast-icon-close:hover {
    background: var(--theme-interaction-hover, rgba(255, 255, 255, 0.1));
}

.p-toast .p-toast-message .p-toast-icon-close .p-toast-icon-close-icon {
    font-size: 0.75rem;
}

/* Success notification */
.p-toast .p-toast-message.p-toast-message-success {
    border-left: 4px solid #22c55e;
}

.p-toast .p-toast-message.p-toast-message-success .p-toast-message-icon {
    color: #22c55e;
    font-size: 1.1rem;
    margin-right: 0.75rem;
}

/* Favorite success notification (gold) */
.p-toast .p-toast-message.favorite-notification {
    border-left: 4px solid #FFD700 !important;
}

.p-toast .p-toast-message.favorite-notification .p-toast-message-icon {
    color: #FFD700 !important;
}

/* Error notification */
.p-toast .p-toast-message.p-toast-message-error {
    border-left: 4px solid #ef4444;
}

.p-toast .p-toast-message.p-toast-message-error .p-toast-message-icon {
    color: #ef4444;
    font-size: 1.1rem;
    margin-right: 0.75rem;
}

/* Warning notification */
.p-toast .p-toast-message.p-toast-message-warn {
    border-left: 4px solid #f59e0b;
}

.p-toast .p-toast-message.p-toast-message-warn .p-toast-message-icon {
    color: #f59e0b;
    font-size: 1.1rem;
    margin-right: 0.75rem;
}

/* Info notification */
.p-toast .p-toast-message.p-toast-message-info {
    border-left: 4px solid #3b82f6;
}

.p-toast .p-toast-message.p-toast-message-info .p-toast-message-icon {
    color: #3b82f6;
    font-size: 1.1rem;
    margin-right: 0.75rem;
}

/* Animation improvements */
.p-toast .p-toast-message {
    animation: toast-slide-in 0.3s ease-out;
}

@keyframes toast-slide-in {
    from {
        transform: translateX(100%);
        opacity: 0;
    }
    to {
        transform: translateX(0);
        opacity: 1;
    }
}

.p-toast .p-toast-message.p-toast-message-leave {
    animation: toast-slide-out 0.3s ease-in forwards;
}

@keyframes toast-slide-out {
    from {
        transform: translateX(0);
        opacity: 1;
    }
    to {
        transform: translateX(100%);
        opacity: 0;
    }
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .p-toast {
        left: 1rem !important;
        right: 1rem !important;
        top: 1rem !important;
        width: auto !important;
    }
    
    .p-toast .p-toast-message {
        min-width: auto;
        max-width: none;
        width: 100%;
    }
}
</style>
